<script>
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewQuestionaryDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      category: {},
    };
  },
  /* created() {
    const { query, params } = this.urlParser('/questionary/questions/', this.path);

    this.query = query;
    this.params = params;
  }, */
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    submit() {
      if (!this.category.id) {
        this.showErrorMessage('Bitte wählen Sie eine Kategorie aus.');
      } else {
        this.$router.push(`/questionary?categoryId=${this.category.id}`);
        this.$emit('submit');
      }
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="600px">

    <v-card>
      <v-card-title class="title pa-3">
        Neuer Fragenkatalog
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex xs12 md6 py-0>
              <rbx-remote-combobox
                v-model="category"
                label="Kategorie"
                :selected="category"
                domain="Category"
              />
            </v-flex>

            <i>Hinweis: Die ausgewählte Kategorie kann nicht nachträglich geändert werden.</i>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               flat>
          OK
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
